export default __webpack_public_path__ + "static/media/small-next-white-icon.b0891a0d.svg";